import gql from 'graphql-tag';

export default gql`
  mutation uploadFileMutation($files: FilesTC, $filesMetaInfo: [FilesMetaInfoDataTC]) {
    uploadFileMutation(files: $files, filesMetaInfo: $filesMetaInfo) {
      uploadId
    }
  }
`;
